<template>
<div class="edit-dates-tab-content">
  <a-form layout="horizontal" :label-col="{span: 12}" :wrapper-col="{span:12}">
    <h4>Koopovereenkomst</h4>

    <a-form-item :has-feedback="hasFeedback('offer_given_to_customer_date')"
                 :validate-status="hasFeedback('offer_given_to_customer_date') ? 'error' : null"
                 :help="getFeedbackString('offer_given_to_customer_date')"
                 label="Koopovereenkomst aan de koper ter hand gesteld op">
      <a-date-picker :format="DateFormatEnum.DISPLAY_DATE"
                     :value-format="DateFormatEnum.DATE"
                             v-model="mortgage.offer_given_to_customer_date"
                             @change="(event) => {fetchOfferCoolingOffPeriodDate(event); deleteError('offer_given_to_customer_date');}"
                             class="offer-given-to-customer-date"
      />
    </a-form-item>

    <a-form-item :has-feedback="hasFeedback('offer_cooling_offperiod_date')"
                 :validate-status="hasFeedback('offer_cooling_offperiod_date') ? 'error' : null"
                 :help="getFeedbackString('offer_cooling_offperiod_date')"
                 label="Wettelijke bedenktijd van de koper (artikel 16) eindigt op">
      <a-date-picker :format="DateFormatEnum.DISPLAY_DATE"
                     :value-format="DateFormatEnum.DATE"
                             v-model="mortgage.offer_cooling_offperiod_date"
                             @change="deleteError('offer_cooling_offperiod_date')"
                             :loading="loadingOfferCoolingOffPeriod"
                             class="offer-cooling-offperiod-date"
      />
    </a-form-item>

    <a-form-item :has-feedback="hasFeedback('end_financing_reservation_date')"
                 :validate-status="hasFeedback('end_financing_reservation_date') ? 'error' : null"
                 :help="getFeedbackString('end_financing_reservation_date')"
                 label="Ontbindende voorwaarden koopovereenkomst (artikel 15) eindigt op">
      <a-date-picker :format="DateFormatEnum.DISPLAY_DATE"
                     :value-format="DateFormatEnum.DATE"
                             v-model="mortgage.end_financing_reservation_date"
                             @change="deleteError('end_financing_reservation_date')"
                             class="end-financing-reservation-date"
      />
    </a-form-item>

    <a-form-item :has-feedback="hasFeedback('bank_guarantee_date')"
                 :validate-status="hasFeedback('bank_guarantee_date') ? 'error' : null"
                 :help="getFeedbackString('bank_guarantee_date')"
                 label="De bankgarantie of waarborgsom dient (artikel 5) dient geregeld te zijn op">
      <a-date-picker :format="DateFormatEnum.DISPLAY_DATE"
                     :value-format="DateFormatEnum.DATE"
                             v-model="mortgage.bank_guarantee_date"
                             @change="deleteError('bank_guarantee_date')"
                             class="bank-guarantee-date"
      />
    </a-form-item>

    <a-form-item label="De eigendomsoverdracht (artikel 4) staat gepland op">
      {{ mortgage.passeerdatum ? (toDate(mortgage.passeerdatum, 'DD/MM/YYYY')) : 'Onbekend' }}
    </a-form-item>

    <a-divider />

    <h4>Renteaanbod</h4>

    <a-form-item :has-feedback="hasFeedback('interest_offer_date')"
                 :validate-status="hasFeedback('interest_offer_date') ? 'error' : null"
                 :help="getFeedbackString('interest_offer_date')"
                 label="Datum renteaanbod uitgebracht">
      <a-date-picker :format="DateFormatEnum.DISPLAY_DATE"
                     :value-format="DateFormatEnum.DATE"
                             v-model="mortgage.interest_offer_date"
                             @change="deleteError('interest_offer_date')"
                             class="interest-offer-date"
      />
    </a-form-item>

    <a-form-item :has-feedback="hasFeedback('validity_unsigned_offer_date')"
                 :validate-status="hasFeedback('validity_unsigned_offer_date') ? 'error' : null"
                 :help="getFeedbackString('validity_unsigned_offer_date')"
                 label="Ongetekend renteaanbod geldig tot">
      <a-date-picker :format="DateFormatEnum.DISPLAY_DATE"
                     :value-format="DateFormatEnum.DATE"
                             v-model="mortgage.validity_unsigned_offer_date"
                             @change="deleteError('validity_unsigned_offer_date')"
                             class="validity-unsigned-offer-date"
      />
    </a-form-item>

    <a-form-item :has-feedback="hasFeedback('validity_signed_offer_date')"
                 :validate-status="hasFeedback('validity_signed_offer_date') ? 'error' : null"
                 :help="getFeedbackString('validity_signed_offer_date')"
                 label="Na ondertekening renteaanbod is deze geldig tot">
      <a-date-picker :format="DateFormatEnum.DISPLAY_DATE"
                     :value-format="DateFormatEnum.DATE"
                             v-model="mortgage.validity_signed_offer_date"
                             @change="deleteError('validity_signed_offer_date')"
                             class="validity-signed-offer-date"
      />
    </a-form-item>

    <a-divider />

    <h4>Offerte</h4>

    <a-form-item :has-feedback="hasFeedback('quotation_date')"
                 :validate-status="hasFeedback('quotation_date') ? 'error' : null"
                 :help="getFeedbackString('quotation_date')"
                 label="Datum offerte uitgebracht">
      <a-date-picker :format="DateFormatEnum.DISPLAY_DATE"
                     :value-format="DateFormatEnum.DATE"
                             v-model="mortgage.quotation_date"
                             @change="deleteError('quotation_date')"
                             class="quotation-date"
      />
    </a-form-item>

    <a-form-item :has-feedback="hasFeedback('final_offer_date')"
                 :validate-status="hasFeedback('final_offer_date') ? 'error' : null"
                 :help="getFeedbackString('final_offer_date')"
                 label="De definitieve offerte dient te worden ondertekend voor">
      <a-date-picker :format="DateFormatEnum.DISPLAY_DATE"
                     :value-format="DateFormatEnum.DATE"
                             v-model="mortgage.final_offer_date"
                             @change="deleteError('final_offer_date')"
                             class="final-offer-date"
      />
    </a-form-item>

    <a-form-item :has-feedback="hasFeedback('offer_expire_date')"
                 :validate-status="hasFeedback('offer_expire_date') ? 'error' : null"
                 :help="getFeedbackString('offer_expire_date')"
                 label="Na ondertekening definitieve offerte is deze geldig tot">
      <a-date-picker :format="DateFormatEnum.DISPLAY_DATE"
                     :value-format="DateFormatEnum.DATE"
                             v-model="mortgage.offer_expire_date"
                             @change="deleteError('offer_expire_date')"
                             class="offer-expire-date"
      />
    </a-form-item>

    <a-form-item :has-feedback="hasFeedback('quotation_extend_date')"
                 :validate-status="hasFeedback('quotation_extend_date') ? 'error' : null"
                 :help="getFeedbackString('quotation_extend_date')"
                 label="Geldigheidsduur offerte te verlengen tot">
      <a-date-picker :format="DateFormatEnum.DISPLAY_DATE"
                     :value-format="DateFormatEnum.DATE"
                             v-model="mortgage.quotation_extend_date"
                             @change="deleteError('quotation_extend_date')"
                             class="quotation-extend-date"
      />
    </a-form-item>

  </a-form>
</div>
</template>

<script>
import {mapGetters} from "vuex";
import mortgageApi from '~/api/mortgage';
import {toDate} from "~/plugins/string-helpers";
import show_backend_feedback from "~/modules/mortgage/mixins/show_backend_feedback";
import {DateFormatEnum} from "~/enums";

export default {
  name: 'MortgageEditDatesComponent',
  props: {
    mortgageId: Number
  },
  data() {
    return {
      loadingOfferCoolingOffPeriod: false,
      toDate: toDate,
      DateFormatEnum: DateFormatEnum,
      properties: [
          'offer_given_to_customer_date',
          'offer_cooling_offperiod_date',
          'end_financing_reservation_date',
          'bank_guarantee_date',
          'interest_offer_date',
          'validity_unsigned_offer_date',
          'validity_signed_offer_date',
          'quotation_date',
          'final_offer_date',
          'offer_expire_date',
          'quotation_extend_date'
      ]
    }
  },
  mixins: [
    show_backend_feedback
  ],
  methods: {
    async fetchOfferCoolingOffPeriodDate(newOfferGivenDate) {
      this.loadingOfferCoolingOffPeriod = true;
      try{
        let response = await mortgageApi.fetchOfferCoolingOffPeriodDate(toDate(newOfferGivenDate, DateFormatEnum.DATE));

        this.mortgage.offer_cooling_offperiod_date = response.offerCoolingOffPeriodDate;
      } catch (e) {
        this.$notification['error']({
          message: "Er is iets mis gegaan",
          description: "De wettelijke bedenktijd kon niet worden opgehaald, vul zelf de datum in."
        })
      } finally {
        this.loadingOfferCoolingOffPeriod = false;
      }
    }
  },
  computed:{
    ...mapGetters({
      mortgage: 'mortgage/mortgage'
    }),
    getFeedbackObject() {
      return this.mortgage;
    }
  }
}
</script>

<style scoped>

</style>